import React, { Component } from 'react';
import HeaderButtons from './HeaderButtons.jsx';

import {
    searchConfigurationSession,
    resetStateConfigSesionVista,
    guardarConfiguracion
} from '../actions/ConfiguracionSesionEditar';

class Headers extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searchUser: ""
        }
    }

    cleanStorage(){
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }
    }

    render() {
        return (
            <div className="row user-list bottom-separator-xxs">
                <div className="col-md-7">
                    <HeaderButtons
                        functions={this.props.functions}
                        guardarConfiguracion={this.props.guardarConfiguracion}
                        configuracion={this.props.configuracion}
                        cleanStorage={this.cleanStorage}
                    />
                </div>
            </div>
        );
    }
};

export default Headers